<template>
  <div id="glossary">
    <div class="inner-wrapper">
      <main class="inner-content">
        <header>
          <h1 class="app-title">Glossary of terms</h1>
          <a href="#" @click="goBack" class="btn back"
            ><img class="arrow" src="@/assets/img/arrow-up-icon.svg" />Back</a
          >
        </header>

        <div class="row"></div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "Glossary",
  methods: {
    goBack(e) {
      e.preventDefault();
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
#glossary {
  position: relative;
  padding-bottom: 3rem;

  header {
    position: relative;
  }

  .row {
    margin-top: 2rem;
  }

  ol {
    li {
      margin-bottom: 1rem;
    }
  }

  hr {
    margin: 2rem 0;
  }

  h2 {
    margin-bottom: 1rem;
  }

  .btn.back {
    position: absolute;
    top: 0;
    right: 0;
    &:focus {
      outline: 4px solid#FFD086;
    }
  }
}
</style>